import React from "react";
import { CollectionIcon } from "../../assets/images/collection";
import { ConfigIcon } from "../../assets/images/config";
import { ContractIcon } from "../../assets/images/contract";
import { OverviewIcon } from "../../assets/images/home";
import { ManualIcon } from "../../assets/images/manual";
import { ReportIcon } from "../../assets/images/report";
import { SettlementIcon } from "../../assets/images/settlement";
import { roles } from "../../lib/constants";

export const getTabKey = (role, currentPath, view = "") => {
  const roleKeys = {
    AgencyManager: {
      "collection-view": true,
    },
    Operator: {
      "collection-view": true,
      "settlement-view": true,
      "contract-view": true,
    },
    Admin: {
      overview: true,
      collection: true,
      settlement: true,
      contract: true,
    },
    Finance: {
      overview: true,
      collection: true,
      settlement: true,
      contract: true,
    },
    CityManager: {
      overview: true,
      collection: true,
      settlement: true,
      contract: true,
    },
    Superadmin: {
      overview: true,
      collection: true,
      settlement: true,
      contract: true,
      report: true,
    },
  };

  if (view === "mobile") {
    if (roleKeys[role] && roleKeys[role][currentPath]) return currentPath;
    if (role === "AgencyManager" || role === "Operator") return "collection-view";
    return "collection-view";
  }
  roleKeys.AgencyManager.overview = true;
  roleKeys.AgencyManager.report = true;
  roleKeys.Admin.report = true;
  roleKeys.CityManager.report = true;

  if (roleKeys[role] && roleKeys[role][currentPath]) return currentPath;
  if (role === "Operator") return "collection-view";
  return "overview";
};

export const drawerWidth = 235;

// export const reportsMenu = [
//   { name: 'Report', key: 'reports', auth: [] },
//   { name: 'Distance', key: 'distance', auth: [] },
//   { name: 'Bulk Edit-GC', key: 'bulk-edit-gross-contribution', auth: [] },
//   { name: 'Expenses', key: 'expenses', auth: [] },
//   { name: 'Pass Revenue', key: 'pass-revenue', auth: [] },
// ];

export const manualEntryMenu = [
  { name: "Distance", key: "distance", auth: [] },
  { name: "Bulk Edit-GC", key: "bulk-edit-gross-contribution", auth: [] },
  { name: "Expenses", key: "expenses", auth: [] },
  { name: "Pass Revenue", key: "pass-revenue", auth: [] },
];

export const systemConfigsMenu = [
  { name: "Operator Config", key: "operator-config", auth: [] },
  { name: "Agency Config", key: "agency-config", auth: [roles.superAdmin] },
  { name: "City Config", key: "city-config", auth: [roles.superAdmin] },
];

export const menu = [
  {
    name: "Overview",
    key: "overview",
    icon: (props) => <OverviewIcon {...props} />,
    auth: [roles.admin, roles.cityManager, roles.agencyManager, roles.finance, roles.superAdmin],
  },
  {
    name: "Collection",
    key: "collection",
    icon: (props) => <CollectionIcon {...props} />,
    auth: [],
  },
  {
    name: "Settlements",
    key: "settlement",
    icon: (props) => <SettlementIcon {...props} />,
    auth: [roles.admin, roles.cityManager, roles.finance, roles.operator, roles.superAdmin],
  },
  {
    name: "Contracts",
    key: "contract",
    icon: (props) => <ContractIcon {...props} />,
    auth: [roles.admin, roles.cityManager, roles.finance, roles.operator, roles.superAdmin],
  },
  {
    name: "Reports",
    key: "report",
    icon: (props) => <ReportIcon {...props} />,
    auth: [roles.admin, roles.cityManager, roles.agencyManager, roles.finance, roles.superAdmin],
  },
  {
    name: "Manual Data Entry",
    key: "manual",
    icon: (props) => <ManualIcon {...props} />,
    auth: [roles.admin, roles.cityManager, roles.finance, roles.superAdmin],
    isExpandable: true,
    expandedMenu: manualEntryMenu,
  },
  {
    name: "System Configs",
    key: "system-config",
    icon: (props) => <ConfigIcon {...props} />,
    auth: [roles.admin, roles.cityManager, roles.finance, roles.superAdmin],
    isExpandable: true,
    expandedMenu: systemConfigsMenu,
  },
];

export const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "black", // Set the background color to black
});

export const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
